import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import BrandImage from './BrandImage';
import { useCurrency } from '../context/CurrencyContext';

const BrandCard = ({ brand }) => {
  const ref = useRef(null);
  const rafRef = useRef(0);
  const { formatPrice } = useCurrency();

  const handleMove = (e) => {
    if (rafRef.current) return;
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    rafRef.current = requestAnimationFrame(() => {
      el.style.transform = `perspective(800px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-4px)`;
      rafRef.current = 0;
    });
  };
  const handleLeave = () => {
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = 0; }
    const el = ref.current;
    if (el) el.style.transform = 'perspective(800px) rotateY(0) rotateX(0) translateY(0)';
  };

  return (
    <Link to={`/product/${brand.id}`} className="group tilt-wrap">
      <div ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave}
        className="bg-white rounded-2xl brand-tile-shadow overflow-hidden transition-transform duration-200 will-change-transform">
        <div className="aspect-[4/3] flex items-center justify-center p-6 relative overflow-hidden"
          style={{ background: `linear-gradient(135deg, ${brand.color}18, ${brand.color}05)` }}>
          <BrandImage brand={brand}
            className="max-h-14 max-w-[70%] object-contain relative z-10 transition-transform duration-500 group-hover:scale-110"
            tileClassName="w-20 h-14 rounded-md text-lg relative z-10" />
          <div className="absolute -top-16 -right-16 w-32 h-32 rounded-full opacity-0 group-hover:opacity-40 transition-opacity duration-500" style={{ background: brand.color, filter: 'blur(30px)' }} />
        </div>
        <div className="px-4 py-3 border-t border-neutral-100 flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-sm font-semibold text-neutral-900 truncate">{brand.name}</div>
            <div className="text-xs text-neutral-500 mt-0.5">From {formatPrice(brand.denominations[0])}</div>
          </div>
          <span className="text-[10px] font-semibold text-[#8247E5] bg-violet-50 px-1.5 py-0.5 rounded shrink-0 ml-2">CRYPTO</span>
        </div>
      </div>
    </Link>
  );
};

export default BrandCard;
